export default {
    searchPlaceholder: 'Search by company name',
    save: 'Save',
};
